import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FoodNoIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FoodNoIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M20.8296 11.5037C20.9908 11.2269 21.0787 10.8946 21.0787 10.5624V8.91503L19.9211 9.81485V10.5624C19.9211 11.0884 19.4815 11.5037 18.9247 11.5037H18.0895V11.0608L16.0381 12.5974H21.3278V12.6666C21.3278 13.0127 21.2985 13.3449 21.2399 13.6772H14.5875L13.1369 14.7708H20.9468C20.0383 17.138 17.6353 18.8269 14.8219 18.8269H10.4847C9.69345 18.8269 8.94616 18.6885 8.24282 18.4393L7.21713 19.2007C8.21352 19.6437 9.31248 19.9067 10.4847 19.9067H14.8219C19.0566 19.9067 22.5 16.6673 22.5 12.6527V11.4899H20.8442L20.8296 11.5037Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.67843 16.8196C5.10697 16.2244 4.63808 15.546 4.34502 14.7708H8.4185L9.86913 13.6772H4.05197C3.99335 13.3449 3.96405 13.0127 3.96405 12.6666V12.5974H11.3344L12.785 11.5038H12.6385C12.448 10.4655 11.7154 9.60721 10.7336 9.19191V7.40611C12.5213 7.41996 13.9573 8.79045 13.9573 10.4793V10.6178L16.4189 8.77661C16.2724 8.74892 16.1112 8.72124 15.95 8.72124H14.7046C14.0012 7.29537 12.4773 6.31249 10.7043 6.31249H6.08871C5.70773 6.31249 5.38537 6.02177 5.38537 5.648C5.38537 5.27423 5.69308 4.98352 6.08871 4.98352H10.1622V3.88989H6.08871C5.06301 3.88989 4.24245 4.67897 4.24245 5.63416C4.24245 6.58935 5.07766 7.37843 6.08871 7.37843H6.55759V7.4338C6.55759 8.08444 6.82135 8.67971 7.24628 9.12269C6.22058 9.538 5.47329 10.4101 5.26815 11.4622H2.80648V12.6251C2.80648 14.4801 3.56842 16.169 4.78461 17.4426L5.67843 16.7642V16.8196ZM7.70051 7.40611H9.57607V8.91504C9.57607 8.91504 9.42954 8.91504 9.35628 8.91504H9.22441C8.37454 8.91504 7.70051 8.2644 7.70051 7.47533V7.40611ZM8.53572 9.99483H9.37093C10.3673 9.99483 11.2025 10.6316 11.4663 11.5038H6.44037C6.68947 10.6316 7.53933 9.99483 8.53572 9.99483Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M22.2507 6.17404C22.0016 5.86949 21.5328 5.82796 21.225 6.0633L2.77717 19.879C2.4548 20.1143 2.41085 20.5573 2.65994 20.848C2.90904 21.1526 3.37793 21.1941 3.68564 20.9588L22.1335 7.14308C22.4559 6.90774 22.4998 6.46475 22.2507 6.17404Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FoodNoIcon;
